const FigureType = {
  NATURAL: 'NATURAL',
  LEGAL: 'LEGAL',
};

export default FigureType;
